import React from 'react';
import { Polygon } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { getZoneOptions } from 'helpers/utils';

const ViewSelectedRowsFromTable = () => {
  const zoneState = useSelector((state) => state.zone.geoRadarZone) ?? null;

  const polygonOptions = getZoneOptions({
    fillColor: 'yellow',
    editable: false,
  });

  return zoneState?.selectedVersionRows.map((selectedRow, index) => (
    <Polygon
      key={index}
      paths={selectedRow?.zonePolygonJson}
      options={polygonOptions}
    />
  ));
};

export default ViewSelectedRowsFromTable;
